module.exports = {
	"ha": "vcha",
	"id": 12,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 370,
			"marginLeft": 180,
			"marginRight": 160,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 180px;\">Figure 12</span>                 <span style=\"display: table-cell;\">AIDS Case Rate and Reports for Vancouver Coastal Health <sup style=\"font-size: 10px;\">18</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018,
					2019
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Rate per 100,000 population",
					"reserveSpace": false,
					"x": -170
				}
			}
		],
		"series": [
			{
				"name": "AIDS: BCCDC Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 4,
				"data": [
					37,
					29,
					24,
					27,
					17,
					17,
					17,
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: BCCDC Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: BCCDC Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 5,
				"data": [
					3.2862015063237173,
					2.544515866372556,
					2.07309025198412,
					2.3156387089027732,
					1.4357041030734203,
					1.4198411949383498,
					1.4039248784572682,
					{
						"y": 0.40809830271915903,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 5,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: BCCDC Reports (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": false,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					48,
					44,
					40,
					32,
					32,
					24,
					19,
					{
						"y": 11,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "CD4<200 at ART Initiation (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					4.3,
					3.9,
					3.5,
					2.7,
					2.7,
					2,
					1.6,
					{
						"y": 0.9,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "CD4<200 at ART Initiation (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					40,
					36,
					41,
					43,
					24,
					14,
					17,
					{
						"y": 10,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: DTP Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 3,
				"data": [
					3.6,
					3.2,
					3.5,
					3.7,
					2,
					1.2,
					1.4,
					{
						"y": 0.8,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 13,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: DTP Reports (PER 100K)",
					"suppressible": false
				}
			}
		]
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_12.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_12.json
// module id = 281
// module chunks = 0